import axios from "axios";
import { del, get, post, patch,  put } from "./file_types_api_helper";
import * as url from "./file_types_url_helper";





// Get features
export const getFileTypes = () => get(url.GET_FILE_TYPES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewFileType = (fileType) => post(url.ADD_NEW_FILE_TYPE, {fileType});


// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateFileType = (fileType) => patch(`${url.UPDATE_FILE_TYPE}/${fileType.id}`,  fileType);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteFileType = (fileType) => del(`${url.DELETE_FILE_TYPE}/${fileType.id}`);







export {
  //getLoggedInUser,
  
  
};
